(function () {
  'use strict';

  var PAGE_SIZE = 18;
  var SEEN_WATCH_KEY = 'gettmi-home-watch-seen-v1';
  var state = {
    activeTab: 'discover', clips: [], feedIndex: 0, feedReady: false, signature: '', visibleCount: 0,
    forYouGateShown: false, forYouPreviewArmed: false, forYouStartScrollY: 0, forYouArmTimer: 0,
    forYouScrollFrame: 0
  };

  function root() {
    return document.querySelector('[data-gettmi-home-discovery]');
  }

  function config() {
    var node = document.querySelector('[data-gettmi-supabase]');
    if (!node) return null;
    var url = String(node.dataset.supabaseUrl || '').replace(/\/+$/, '');
    var key = String(node.dataset.supabaseKey || '');
    return url && key ? { url: url, key: key } : null;
  }

  function publicUrl(cfg, bucket, path) {
    if (!cfg || !bucket || !path) return '';
    return cfg.url + '/storage/v1/object/public/' + encodeURIComponent(String(bucket)) + '/' +
      String(path).split('/').filter(Boolean).map(encodeURIComponent).join('/');
  }

  function safeHttpUrl(value) {
    var candidate = String(value || '').trim();
    if (!candidate) return '';
    try {
      var parsed = new URL(candidate, window.location.origin);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function detectPlatform(value) {
    try {
      var host = new URL(value).hostname.replace(/^www\./, '').toLowerCase();
      if (host === 'tiktok.com' || host.endsWith('.tiktok.com')) return 'tiktok';
      if (host === 'youtube.com' || host.endsWith('.youtube.com') || host === 'youtu.be') return 'youtube';
      if (host === 'instagram.com' || host.endsWith('.instagram.com')) return 'instagram';
    } catch (error) {
      return '';
    }
    return '';
  }

  function embedUrl(clip) {
    if (!clip || !clip.external) return '';
    var url;
    try { url = new URL(clip.external); } catch (error) { return ''; }
    if (clip.platform === 'youtube') {
      var host = url.hostname.replace(/^(www|m)\./, '').toLowerCase();
      var parts = url.pathname.split('/').filter(Boolean);
      var id = host === 'youtu.be' ? parts[0] : parts[0] === 'watch' ? url.searchParams.get('v') :
        ['shorts', 'embed', 'live', 'v'].indexOf(parts[0]) !== -1 ? parts[1] : '';
      return /^[A-Za-z0-9_-]{8,15}$/.test(id || '') ?
        'https://www.youtube.com/embed/' + id + '?autoplay=1&mute=1&playsinline=1&rel=0' : '';
    }
    if (clip.platform === 'tiktok') {
      var video = url.pathname.match(/\/video\/(\d+)/);
      return video ? 'https://www.tiktok.com/embed/v2/' + video[1] : '';
    }
    if (clip.platform === 'instagram') {
      var post = url.pathname.match(/^\/(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/);
      if (!post) return '';
      return 'https://www.instagram.com/' + (post[1] === 'p' ? 'p' : 'reel') + '/' + post[2] + '/embed/';
    }
    return '';
  }

  function readSeenWatch() {
    try { return window.localStorage.getItem(SEEN_WATCH_KEY) || ''; } catch (error) { return ''; }
  }

  function writeSeenWatch(value) {
    try { window.localStorage.setItem(SEEN_WATCH_KEY, value); } catch (error) { /* Navigation remains available. */ }
  }

  function moveForYouContent() {
    var mount = root();
    var panel = mount && mount.querySelector('[data-gettmi-for-you-panel]');
    var styles = document.getElementById('styles');
    if (panel && styles && !panel.contains(styles)) panel.appendChild(styles);
  }

  function disarmForYouPreview() {
    state.forYouPreviewArmed = false;
    if (state.forYouArmTimer) window.clearTimeout(state.forYouArmTimer);
    state.forYouArmTimer = 0;
  }

  function checkForYouPreviewBoundary() {
    if (state.activeTab !== 'shop' || !state.forYouPreviewArmed || state.forYouGateShown) return;
    var boundary = document.querySelector('[data-gettmi-for-you-preview-boundary]');
    if (!boundary) return;
    var travelled = window.scrollY - state.forYouStartScrollY;
    var minimumTravel = Math.min(120, Math.max(64, window.innerHeight * 0.12));
    if (travelled < minimumTravel || boundary.getBoundingClientRect().top > window.innerHeight * 0.84) return;
    if (!window.GettmiAppGate || typeof window.GettmiAppGate.open !== 'function') return;
    var opener = root() && root().querySelector('[data-gettmi-for-you-preview]');
    state.forYouGateShown = window.GettmiAppGate.open('for_you', {
      opener: opener,
      placement: 'home_discovery_preview_boundary'
    });
    if (state.forYouGateShown) disarmForYouPreview();
  }

  function armForYouPreview() {
    disarmForYouPreview();
    if (state.forYouGateShown) return;
    state.forYouArmTimer = window.setTimeout(function () {
      if (state.activeTab !== 'shop') return;
      state.forYouStartScrollY = window.scrollY;
      state.forYouPreviewArmed = true;
    }, 700);
  }

  function scheduleForYouPreviewCheck() {
    if (state.forYouScrollFrame) return;
    state.forYouScrollFrame = window.requestAnimationFrame(function () {
      state.forYouScrollFrame = 0;
      checkForYouPreviewBoundary();
    });
  }

  function setHomeTab(tab) {
    var mount = root();
    if (!mount) return;
    var selected = tab === 'watch' || tab === 'shop' ? tab : 'discover';
    state.activeTab = selected;
    document.body.classList.remove('gettmi-home-tab-discover', 'gettmi-home-tab-shop', 'gettmi-home-tab-watch');
    document.body.classList.add('gettmi-home-tab-' + selected);
    mount.querySelectorAll('[data-gettmi-home-tab]').forEach(function (button) {
      button.setAttribute('aria-selected', String(button.dataset.gettmiHomeTab === selected));
    });
    mount.querySelector('[data-gettmi-for-you-panel]').hidden = selected !== 'shop';
    mount.querySelector('[data-gettmi-clips-panel]').hidden = selected !== 'watch';
    if (selected === 'shop') armForYouPreview();
    else disarmForYouPreview();
    if (selected === 'watch' && state.signature) {
      writeSeenWatch(state.signature);
      mount.querySelector('[data-gettmi-watch-unread]').hidden = true;
    }
  }

  function normaliseClip(cfg, row) {
    var thumbnail = safeHttpUrl(row.thumbnail_url) ||
      (row.thumbnail_path ? publicUrl(cfg, row.thumbnail_bucket || 'clips', row.thumbnail_path) : '');
    var external = safeHttpUrl(row.watch_url);
    var legacy = !external && row.video_path ? publicUrl(cfg, 'clip-videos', row.video_path) : '';
    if (!thumbnail || (!external && !legacy)) return null;
    return {
      id: String(row.id || row.watch_url || row.video_path || row.title || ''),
      title: String(row.title || ''), creator: String(row.handle || row.creator || ''),
      platform: String(row.platform || detectPlatform(external)).toLowerCase(),
      thumbnail: thumbnail, external: external, legacy: legacy,
      updatedAt: String(row.updated_at || row.created_at || '')
    };
  }

  var YOUTUBE_THUMBNAILS = ['hq720', 'maxresdefault', 'mqdefault'];

  function youtubeVariant(url, variant) {
    return url.replace(/\/(maxresdefault|sddefault|hqdefault|mqdefault)\.jpg/, '/' + variant + '.jpg');
  }

  function applyThumbnail(image, thumbnail) {
    if (!/^https:\/\/i\.ytimg\.com\/vi\//.test(thumbnail)) { image.src = thumbnail; return; }
    var step = 0;
    image.addEventListener('error', function () {
      step += 1;
      if (step < YOUTUBE_THUMBNAILS.length) image.src = youtubeVariant(thumbnail, YOUTUBE_THUMBNAILS[step]);
    });
    image.src = youtubeVariant(thumbnail, YOUTUBE_THUMBNAILS[0]);
  }

  function createTile(clip, index) {
    var tile = document.createElement('button');
    tile.className = 'gettmi-clip-tile';
    tile.type = 'button';
    tile.dataset.gettmiOpenClipFeed = String(index);
    tile.setAttribute('aria-label', (clip.title || 'Fashion clip') + (clip.creator ? ' by ' + clip.creator : ''));
    var image = document.createElement('img');
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 260;
    image.height = 364;
    applyThumbnail(image, clip.thumbnail);
    var shade = document.createElement('span');
    shade.className = 'gettmi-clip-tile__shade';
    var title = document.createElement('strong');
    title.textContent = clip.title;
    var meta = document.createElement('span');
    meta.className = 'gettmi-clip-tile__meta';
    var play = document.createElement('b');
    play.textContent = '▷';
    var creator = document.createElement('small');
    creator.textContent = clip.creator;
    meta.append(play, creator);
    tile.append(image, shade, title, meta);
    return tile;
  }

  function renderPage() {
    var mount = root();
    if (!mount || !state.clips.length) return;
    var grid = mount.querySelector('[data-gettmi-clips-grid]');
    var nextCount = Math.min(state.visibleCount + PAGE_SIZE, state.clips.length);
    for (var index = state.visibleCount; index < nextCount; index += 1) grid.appendChild(createTile(state.clips[index], index));
    state.visibleCount = nextCount;
    mount.querySelector('[data-gettmi-clips-sentinel]').hidden = state.visibleCount >= state.clips.length;
    mount.querySelector('[data-gettmi-clips-end]').hidden = state.visibleCount < state.clips.length;
  }

  function feedPage(clip, index) {
    var page = document.createElement('section');
    page.className = 'gettmi-clip-feed__page';
    page.dataset.gettmiClipFeedPage = String(index);
    var image = document.createElement('img');
    image.className = 'gettmi-clip-feed__backdrop';
    image.alt = '';
    image.loading = 'lazy';
    applyThumbnail(image, clip.thumbnail);
    var shade = document.createElement('span');
    shade.className = 'gettmi-clip-feed__shade';
    var player = document.createElement('div');
    player.className = 'gettmi-clip-feed__player';
    player.dataset.gettmiClipFeedPlayer = '';
    var credit = document.createElement('div');
    credit.className = 'gettmi-clip-feed__credit';
    var creator = document.createElement('strong');
    creator.textContent = clip.creator;
    var title = document.createElement('span');
    title.textContent = clip.title;
    credit.append(creator, title);
    page.append(image, shade, player, credit);
    return page;
  }

  function buildFeed() {
    var mount = root();
    if (!mount || state.feedReady) return;
    var pages = mount.querySelector('[data-gettmi-clip-feed-pages]');
    state.clips.forEach(function (clip, index) { pages.appendChild(feedPage(clip, index)); });
    var end = document.createElement('section');
    end.className = 'gettmi-clip-feed__page gettmi-clip-feed__end';
    end.dataset.gettmiClipFeedPage = String(state.clips.length);
    end.innerHTML = '<span>✓</span><p>You’re all caught up. New clips land here as our favourite creators post them.</p>' +
      '<a href="/collections/most-wanted">SHOP WHAT’S TRENDING&nbsp;&nbsp;→</a>';
    pages.appendChild(end);
    state.feedReady = true;
  }

  function clearPlayers() {
    var mount = root();
    if (!mount) return;
    mount.querySelectorAll('[data-gettmi-clip-feed-player]').forEach(function (node) { node.replaceChildren(); });
  }

  function activateFeedPage(index) {
    var mount = root();
    if (!mount) return;
    var next = Math.max(0, Math.min(state.clips.length, Number(index) || 0));
    if (state.feedIndex === next && mount.querySelector('[data-gettmi-clip-feed-player] > *')) return;
    state.feedIndex = next;
    clearPlayers();
    var counter = mount.querySelector('[data-gettmi-clip-feed-counter]');
    counter.hidden = next >= state.clips.length;
    counter.textContent = next < state.clips.length ? (next + 1) + ' / ' + state.clips.length : '';
    if (next >= state.clips.length) return;
    var clip = state.clips[next];
    var page = mount.querySelector('[data-gettmi-clip-feed-page="' + next + '"]');
    var player = page && page.querySelector('[data-gettmi-clip-feed-player]');
    if (!player) return;
    var officialEmbed = embedUrl(clip);
    if (officialEmbed) {
      var iframe = document.createElement('iframe');
      iframe.src = officialEmbed;
      iframe.title = clip.title || 'Fashion clip';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      player.appendChild(iframe);
      return;
    }
    if (clip.legacy) {
      var video = document.createElement('video');
      video.src = clip.legacy;
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true;
      player.appendChild(video);
      return;
    }
    var fallback = document.createElement('div');
    fallback.className = 'gettmi-clip-feed__fallback';
    var platform = clip.platform || 'the platform';
    var label = document.createElement('p');
    label.textContent = 'This one plays best on ' + platform;
    var link = document.createElement('a');
    link.href = clip.external;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'WATCH ON ' + platform.toUpperCase() + '  →';
    fallback.append(label, link);
    player.appendChild(fallback);
  }

  function openFeed(index) {
    var mount = root();
    if (!mount) return;
    buildFeed();
    var overlay = mount.querySelector('[data-gettmi-clip-feed]');
    var pages = mount.querySelector('[data-gettmi-clip-feed-pages]');
    overlay.hidden = false;
    document.documentElement.classList.add('gettmi-clip-feed-open');
    window.requestAnimationFrame(function () {
      pages.scrollTop = Math.max(0, Number(index) || 0) * pages.clientHeight;
      state.feedIndex = -1;
      activateFeedPage(index);
    });
  }

  function closeFeed() {
    var mount = root();
    if (!mount) return;
    clearPlayers();
    mount.querySelector('[data-gettmi-clip-feed]').hidden = true;
    document.documentElement.classList.remove('gettmi-clip-feed-open');
  }

  function showEmpty(message) {
    var mount = root();
    if (!mount) return;
    var node = mount.querySelector('[data-gettmi-clips-state]');
    node.classList.add('is-empty');
    node.querySelector('p').textContent = message;
  }

  function loadClips() {
    var mount = root();
    var cfg = config();
    if (!mount || !cfg) { showEmpty('Clips are taking a break. Try again soon.'); return; }
    window.fetch(cfg.url + '/rest/v1/home_clips?' +
      'select=id,title,creator,platform,handle,thumbnail_url,thumbnail_bucket,thumbnail_path,view_count,watch_url,video_path,sort_order,created_at,updated_at' +
      '&order=sort_order.asc', { headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key } })
      .then(function (response) { if (!response.ok) throw new Error('clips'); return response.json(); })
      .then(function (rows) {
        state.clips = (Array.isArray(rows) ? rows : []).map(function (row) { return normaliseClip(cfg, row); }).filter(Boolean);
        state.signature = state.clips.map(function (clip) { return clip.id + ':' + clip.updatedAt; }).join('|');
        if (!state.clips.length) { showEmpty('New clips are coming soon.'); return; }
        mount.querySelector('[data-gettmi-clips-state]').hidden = true;
        mount.querySelector('[data-gettmi-clips-grid]').hidden = false;
        if (state.activeTab === 'watch') writeSeenWatch(state.signature);
        mount.querySelector('[data-gettmi-watch-unread]').hidden =
          state.activeTab === 'watch' || !state.signature || readSeenWatch() === state.signature;
        renderPage();
      }).catch(function () { showEmpty('Clips are taking a break. Try again soon.'); });
  }

  document.addEventListener('click', function (event) {
    var mount = root();
    if (!mount || !event.target.closest) return;
    var tab = event.target.closest('[data-gettmi-home-tab]');
    if (tab) {
      setHomeTab(tab.dataset.gettmiHomeTab);
      mount.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    var clip = event.target.closest('[data-gettmi-open-clip-feed]');
    if (clip) { openFeed(Number(clip.dataset.gettmiOpenClipFeed)); return; }
    if (event.target.closest('[data-gettmi-close-clip-feed]')) closeFeed();
  });

  function boot() {
    var mount = root();
    if (!mount || mount.dataset.gettmiBooted === 'true') return;
    mount.dataset.gettmiBooted = 'true';
    moveForYouContent();
    setHomeTab('discover');
    var sentinel = mount.querySelector('[data-gettmi-clips-sentinel]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) renderPage();
      }, { rootMargin: '900px 0px' }).observe(sentinel);
    }
    var pages = mount.querySelector('[data-gettmi-clip-feed-pages]');
    pages.addEventListener('scroll', function () {
      if (pages.dataset.frame) return;
      pages.dataset.frame = '1';
      window.requestAnimationFrame(function () {
        pages.dataset.frame = '';
        activateFeedPage(Math.round(pages.scrollTop / Math.max(1, pages.clientHeight)));
      });
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!mount.querySelector('[data-gettmi-clip-feed]').hidden) pages.scrollTop = state.feedIndex * pages.clientHeight;
    }, { passive: true });
    window.addEventListener('scroll', scheduleForYouPreviewCheck, { passive: true });
    loadClips();
  }

  window.GettmiClipFeedTest = { detectPlatform: detectPlatform, embedUrl: embedUrl };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
